<template>
  <v-chart :options="chartOptions" auto-resize class="year-aggregated-chart" />
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";

export default {
  components: {
    "v-chart": ECharts,
  },
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    year: {
      type: Number,
      default: new Date().getFullYear(),
    },
  },
  computed: {
    chartOptions() {
      const monthsData = new Array(12).fill(0);

      this.chartData.forEach((item) => {
        const date = new Date(parseInt(item.dateTime));
        if (date.getFullYear() === this.year) {
          const month = date.getMonth();
          monthsData[month]++;
        }
      });

      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["Monthly Counts"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          name: "Month",
        },
        yAxis: {
          type: "value",
          name: "Count",
          minInterval: 1,
        },
        series: [
          {
            name: "Monthly Counts",
            type: "bar",
            data: monthsData,
            itemStyle: {
              color: "#4186f4",
            },
          },
        ],
        label: {
          show: true,
          position: "top",
          color: "#000",
        },
      };
    },
  },
};
</script>

<style scoped>
.year-aggregated-chart {
  width: 100%;
  height: 400px;
}
</style>
